import React, { useState, useEffect } from 'react';
import { API_URL } from '../config';

function LandingPage({ onNavigate }) {
  const [cms, setCms] = useState(null);

  useEffect(() => {
    fetch(`${API_URL}/api/cms`)
      .then(r => r.json())
      .then(data => setCms(data))
      .catch(() => setCms({}));
  }, []);

  // Helper: lee un campo del CMS con fallback
  const c = (seccion, campo, fallback = '') =>
    cms?.[seccion]?.[campo] ?? fallback;

  // Reconstruir galería desde CMS
  const galeria = [1, 2, 3, 4, 5, 6].map(i => ({
    emoji: c('galeria', `img${i}_emoji`, '🎈'),
    title: c('galeria', `img${i}_titulo`, 'Evento'),
    img:   c('galeria', `img${i}_url`, ''),
  })).filter(g => g.img);

  // Si no hay galería en el CMS, usar la original
  const galeriaFinal = galeria.length > 0 ? galeria : [
    { emoji: '🎂', title: 'Cumpleaños',     img: 'https://images.unsplash.com/photo-1558636508-e0db3814a69e?w=400&h=400&fit=crop' },
    { emoji: '🎈', title: 'Globos Gigantes',img: 'https://images.unsplash.com/photo-1464207687429-7505649dae38?w=400&h=400&fit=crop' },
    { emoji: '💍', title: 'Bodas',          img: 'https://images.unsplash.com/photo-1519671482677-e0dc66efaadb?w=400&h=400&fit=crop' },
    { emoji: '🎉', title: 'Baby Shower',    img: 'https://images.unsplash.com/photo-1551836022-d5d88e8e5f85?w=400&h=400&fit=crop' },
    { emoji: '🎁', title: 'Sorpresas',      img: 'https://images.unsplash.com/photo-1513895795424-2c3f71d47b54?w=400&h=400&fit=crop' },
    { emoji: '🎪', title: 'Eventos',        img: 'https://images.unsplash.com/photo-1577720643272-265f434b4d8a?w=400&h=400&fit=crop' },
  ];

  // Reconstruir servicios desde CMS
  const servicios = [1, 2, 3, 4, 5, 6].map(i => ({
    icon:  c('servicios', `s${i}_icono`,  '🎈'),
    title: c('servicios', `s${i}_titulo`, ''),
    desc:  c('servicios', `s${i}_desc`,   ''),
  })).filter(s => s.title);

  const serviciosFinal = servicios.length > 0 ? servicios : [
    { icon: '🎈', title: 'Globos Personalizados', desc: 'Diseños únicos y a medida para cualquier ocasión' },
    { icon: '🎂', title: 'Cumpleaños',  desc: 'Decoraciones mágicas que hacen especial tu día' },
    { icon: '💍', title: 'Bodas y Eventos', desc: 'Elegancia y sofisticación para momentos importantes' },
    { icon: '🎉', title: 'Baby Shower', desc: 'Ambientes dulces y acogedores para la llegada' },
    { icon: '🎁', title: 'Sorpresas',   desc: 'Detalles personalizados que enamoran' },
    { icon: '🏢', title: 'Eventos Corporativos', desc: 'Impacto visual para marca y evento' },
  ];

  // WhatsApp
  const waNumero  = c('contacto', 'whatsapp', '5215551234567');
  const waMensaje = c('contacto', 'mensaje_default', 'Hola! Me interesa cotizar una decoración con globos 🎈');
  const waUrl     = `https://wa.me/${waNumero}?text=${encodeURIComponent(waMensaje)}`;
  const igUsuario = c('contacto', 'instagram_usuario', 'sonrie_globos');

  return (
    <div style={{fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif', color: '#172b4d'}}>
      {/* NAVBAR */}
      <nav style={{backgroundColor: '#fff', borderBottom: '1px solid #e1e4e8', padding: '16px 24px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', position: 'sticky', top: 0, zIndex: 100, boxShadow: '0 1px 3px rgba(0,0,0,0.05)'}}>
        <div style={{display: 'flex', alignItems: 'center'}}>
          <img src="/logo.jpeg" alt="Sonrie Globos" style={{height: '42px', objectFit: 'contain'}} />
        </div>
        <button onClick={() => onNavigate('login')} style={{padding: '10px 24px', backgroundColor: '#FF1493', color: 'white', border: 'none', borderRadius: '6px', cursor: 'pointer', fontWeight: '600', fontSize: '14px'}}>
          Acceder al CRM
        </button>
      </nav>

      {/* HERO */}
      <section style={{background: 'linear-gradient(135deg, #FF1493 0%, #FF69B4 100%)', color: 'white', padding: '80px 24px', textAlign: 'center', position: 'relative', overflow: 'hidden'}}>
        <div style={{position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, opacity: 0.1, backgroundImage: 'radial-gradient(circle, white 1px, transparent 1px)', backgroundSize: '20px 20px'}}></div>
        <div style={{maxWidth: '900px', margin: '0 auto', position: 'relative', zIndex: 1}}>
          <div style={{fontSize: '72px', fontWeight: '800', marginBottom: '20px', lineHeight: '1.2'}}>
            {c('hero', 'titulo', 'Haz Sonreír Cada Momento')}
          </div>
          <p style={{fontSize: '20px', marginBottom: '40px', opacity: 0.95, lineHeight: '1.6'}}>
            {c('hero', 'subtitulo', 'Globos personalizados, decoraciones mágicas y eventos que dejan huella.')}
          </p>
          <div style={{display: 'flex', gap: '16px', justifyContent: 'center', flexWrap: 'wrap'}}>
            <button onClick={() => onNavigate('login')} style={{padding: '14px 32px', backgroundColor: 'white', color: '#FF1493', border: 'none', borderRadius: '6px', cursor: 'pointer', fontWeight: '600', fontSize: '15px'}}>
              {c('hero', 'boton_texto', 'Ver Eventos')}
            </button>
            <a href={`https://instagram.com/${igUsuario}`} target="_blank" rel="noopener noreferrer" style={{padding: '14px 32px', backgroundColor: 'rgba(255,255,255,0.2)', color: 'white', border: '2px solid white', borderRadius: '6px', cursor: 'pointer', fontWeight: '600', fontSize: '15px', textDecoration: 'none'}}>
              Instagram
            </a>
          </div>
        </div>
      </section>

      {/* STATS */}
      <section style={{padding: '60px 24px', backgroundColor: '#f8f9fa'}}>
        <div style={{maxWidth: '1200px', margin: '0 auto', display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '40px', textAlign: 'center'}}>
          {[1, 2, 3, 4].map(i => (
            <div key={i}>
              <div style={{fontSize: '48px', fontWeight: '800', color: '#FF1493', marginBottom: '8px'}}>
                {c('stats', `stat_${i}_numero`, '')}
              </div>
              <div style={{fontSize: '16px', color: '#626f86', fontWeight: '500'}}>
                {c('stats', `stat_${i}_label`, '')}
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* SERVICIOS */}
      <section style={{padding: '80px 24px', backgroundColor: 'white'}}>
        <div style={{maxWidth: '1200px', margin: '0 auto'}}>
          <h2 style={{fontSize: '44px', fontWeight: '800', marginBottom: '12px', textAlign: 'center', color: '#172b4d'}}>Nuestros Servicios</h2>
          <p style={{fontSize: '16px', color: '#626f86', textAlign: 'center', marginBottom: '60px', maxWidth: '600px', margin: '0 auto 60px'}}>
            Transformamos eventos en experiencias memorables con creatividad y atención al detalle
          </p>
          <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '30px'}}>
            {serviciosFinal.map((s, i) => (
              <div key={i} style={{backgroundColor: '#fff5f8', padding: '32px', borderRadius: '12px', border: '1px solid #FFE4F0', transition: 'all 0.3s', cursor: 'pointer'}}
                onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-8px)'; e.currentTarget.style.boxShadow = '0 12px 24px rgba(255,20,147,0.1)'; }}
                onMouseLeave={e => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = 'none'; }}>
                <div style={{fontSize: '40px', marginBottom: '16px'}}>{s.icon}</div>
                <h3 style={{fontSize: '18px', fontWeight: '700', marginBottom: '8px', color: '#172b4d'}}>{s.title}</h3>
                <p style={{fontSize: '14px', color: '#626f86', margin: 0}}>{s.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* GALERÍA */}
      <section style={{padding: '80px 24px', backgroundColor: '#f8f9fa'}}>
        <div style={{maxWidth: '1200px', margin: '0 auto'}}>
          <h2 style={{fontSize: '44px', fontWeight: '800', marginBottom: '60px', textAlign: 'center', color: '#172b4d'}}>Nuestro Trabajo</h2>
          <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '24px'}}>
            {galeriaFinal.map((item, i) => (
              <div key={i} style={{borderRadius: '12px', overflow: 'hidden', boxShadow: '0 4px 12px rgba(0,0,0,0.1)', cursor: 'pointer', transition: 'all 0.3s', backgroundColor: 'white'}}
                onMouseEnter={e => { e.currentTarget.style.transform = 'scale(1.05)'; e.currentTarget.style.boxShadow = '0 12px 24px rgba(255,20,147,0.2)'; }}
                onMouseLeave={e => { e.currentTarget.style.transform = 'scale(1)'; e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.1)'; }}>
                <div style={{position: 'relative', paddingBottom: '100%', overflow: 'hidden', backgroundColor: '#f0f0f0'}}>
                  <img src={item.img} alt={item.title} style={{position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', objectFit: 'cover'}} />
                  <div style={{position: 'absolute', bottom: 0, left: 0, right: 0, background: 'linear-gradient(to top, rgba(0,0,0,0.7), transparent)', color: 'white', padding: '20px', display: 'flex', alignItems: 'flex-end', gap: '12px', height: '100%', justifyContent: 'flex-end', flexDirection: 'column'}}>
                    <div style={{fontSize: '24px'}}>{item.emoji}</div>
                    <div style={{fontSize: '16px', fontWeight: '600'}}>{item.title}</div>
                  </div>
                </div>
              </div>
            ))}
          </div>
          <div style={{textAlign: 'center', marginTop: '48px'}}>
            <a href={`https://instagram.com/${igUsuario}`} target="_blank" rel="noopener noreferrer" style={{padding: '14px 32px', backgroundColor: '#FF1493', color: 'white', border: 'none', borderRadius: '6px', cursor: 'pointer', fontWeight: '600', fontSize: '15px', textDecoration: 'none', display: 'inline-block'}}>
              Ver más en Instagram →
            </a>
          </div>
        </div>
      </section>

      {/* POR QUÉ NOSOTROS */}
      <section style={{padding: '80px 24px', backgroundColor: 'white'}}>
        <div style={{maxWidth: '1200px', margin: '0 auto'}}>
          <h2 style={{fontSize: '44px', fontWeight: '800', marginBottom: '60px', textAlign: 'center', color: '#172b4d'}}>¿Por qué elegir Sonrie Globos?</h2>
          <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '40px'}}>
            {[
              { icon: '✨', title: 'Creatividad sin límites', desc: 'Diseños únicos y personalizados para tu evento' },
              { icon: '⚡', title: 'Respuesta rápida',       desc: 'Te salvamos el día cuando lo necesitas' },
              { icon: '💳', title: 'Facturación',            desc: 'Documentamos todo correctamente' },
              { icon: '📱', title: 'Múltiples pagos',        desc: 'Anticipo y complemento flexible' },
              { icon: '🎨', title: 'Calidad garantizada',    desc: 'Materiales premium en todos nuestros trabajos' },
              { icon: '👥', title: '7+ años de confianza',   desc: 'Miles de eventos exitosos' },
            ].map((w, i) => (
              <div key={i} style={{textAlign: 'center'}}>
                <div style={{fontSize: '48px', marginBottom: '16px'}}>{w.icon}</div>
                <h3 style={{fontSize: '16px', fontWeight: '700', marginBottom: '8px', color: '#172b4d'}}>{w.title}</h3>
                <p style={{fontSize: '14px', color: '#626f86', margin: 0}}>{w.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* TESTIMONIO */}
      <section style={{padding: '80px 24px', backgroundColor: '#f8f9fa'}}>
        <div style={{maxWidth: '900px', margin: '0 auto', textAlign: 'center', backgroundColor: '#fff5f8', padding: '60px', borderRadius: '16px', border: '2px solid #FFE4F0'}}>
          <div style={{fontSize: '48px', marginBottom: '24px'}}>⭐⭐⭐⭐⭐</div>
          <p style={{fontSize: '20px', fontWeight: '600', marginBottom: '16px', color: '#172b4d', fontStyle: 'italic'}}>
            {c('testimonio', 'texto', '"Los mejores en decoración de globos."')}
          </p>
          <p style={{fontSize: '15px', color: '#626f86', margin: 0, fontWeight: '500'}}>
            {c('testimonio', 'nombre', 'María González - Zapopan')}
          </p>
        </div>
      </section>

      {/* CTA FINAL */}
      <section style={{padding: '80px 24px', background: 'linear-gradient(135deg, #FF1493 0%, #FF69B4 100%)'}}>
        <div style={{maxWidth: '800px', margin: '0 auto', textAlign: 'center', color: 'white'}}>
          <h2 style={{fontSize: '40px', fontWeight: '800', marginBottom: '20px'}}>
            {c('cta', 'titulo', '¿Listo para hacer tu evento especial?')}
          </h2>
          <p style={{fontSize: '18px', marginBottom: '40px', opacity: 0.95}}>
            {c('cta', 'subtitulo', 'Contacta con nosotros hoy y transforma tu fiesta en una experiencia memorable')}
          </p>
          <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '20px', marginBottom: '40px'}}>
            <div>
              <div style={{fontSize: '14px', opacity: 0.9, marginBottom: '8px'}}>📱 WhatsApp</div>
              <a href={waUrl} target="_blank" rel="noopener noreferrer" style={{fontSize: '18px', fontWeight: '700', color: 'white', textDecoration: 'none'}}>
                Envíanos un mensaje
              </a>
            </div>
            <div>
              <div style={{fontSize: '14px', opacity: 0.9, marginBottom: '8px'}}>📍 Ubicación</div>
              <div style={{fontSize: '18px', fontWeight: '700'}}>
                {c('contacto', 'ciudad', 'Zapopan, Jalisco')}
              </div>
            </div>
            <div>
              <div style={{fontSize: '14px', opacity: 0.9, marginBottom: '8px'}}>📸 Instagram</div>
              <a href={`https://instagram.com/${igUsuario}`} target="_blank" rel="noopener noreferrer" style={{fontSize: '18px', fontWeight: '700', color: 'white', textDecoration: 'none'}}>
                @{igUsuario}
              </a>
            </div>
          </div>
          <button onClick={() => onNavigate('login')} style={{padding: '16px 48px', backgroundColor: 'white', color: '#FF1493', border: 'none', borderRadius: '6px', cursor: 'pointer', fontWeight: '700', fontSize: '16px'}}>
            Acceder al CRM
          </button>
        </div>
      </section>

      {/* FOOTER */}
      <footer style={{backgroundColor: '#172b4d', color: 'white', padding: '40px 24px', textAlign: 'center'}}>
        <div style={{maxWidth: '1200px', margin: '0 auto'}}>
          <div style={{marginBottom: '24px', display: 'flex', justifyContent: 'center'}}>
            <img src="/logo.jpeg" alt="Sonrie Globos" style={{height: '38px', objectFit: 'contain', opacity: 0.9}} />
          </div>
          <p style={{fontSize: '14px', opacity: 0.8, margin: '0 0 16px 0'}}>
            {c('footer', 'tagline', 'Transformando momentos en recuerdos desde Zapopan ✨')}
          </p>
          <div style={{fontSize: '12px', opacity: 0.6}}>
            © {c('footer', 'año', '2026')} Sonrie Globos. Todos los derechos reservados.
          </div>
        </div>
      </footer>
    </div>
  );
}

export default LandingPage;
